import i18n, {t} from 'i18next';

export const tDouble = (key: string) => (): string => i18n.t(key);

export const tStr = (key: string): string => i18n.t(key);

export const superT = (key: string) => {
  return t(key) || tDouble(key) || tStr(key)
}